const holidaysBlock = value => {
  return {
      type: 'HOLIDAYSBLOCK',
      data: value
    };
}
export default holidaysBlock;
